/* tslint:disable */
/* eslint-disable */
/**
 * Client Signup API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { OrganizationAndCompanies } from './';
import {
    OrganizationAndCompaniesFromJSON,
    OrganizationAndCompaniesFromJSONTyped,
    OrganizationAndCompaniesToJSON,
} from './';
import type { SignupStep } from './';
import {
    SignupStepFromJSON,
    SignupStepFromJSONTyped,
    SignupStepToJSON,
} from './';

/**
 * 
 * @export
 * @interface StepCompanyChoice
 */
export interface StepCompanyChoice extends SignupStep {
    /**
     * The list of organization(s) detected from the user email domain, with their companies.
     * @type {Array<OrganizationAndCompanies>}
     * @memberof StepCompanyChoice
     */
    organizationsAndCompanies: Array<OrganizationAndCompanies>;
    /**
     * 
     * @type {boolean}
     * @memberof StepCompanyChoice
     */
    edrMatches: boolean;
    /**
     * 
     * @type {string}
     * @memberof StepCompanyChoice
     */
    nameOfCompanyThatUserWantedToJoinButIsArchived?: string;
}

/**
 * Check if a given object implements the StepCompanyChoice interface.
 */
export function instanceOfStepCompanyChoice(value: object): value is StepCompanyChoice {
    if (!('organizationsAndCompanies' in value) || value['organizationsAndCompanies'] === undefined) return false;
    if (!('edrMatches' in value) || value['edrMatches'] === undefined) return false;
    return true;
}

export function StepCompanyChoiceFromJSON(json: any): StepCompanyChoice {
    return StepCompanyChoiceFromJSONTyped(json, false);
}

export function StepCompanyChoiceFromJSONTyped(json: any, ignoreDiscriminator: boolean): StepCompanyChoice {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...SignupStepFromJSONTyped(json, ignoreDiscriminator),
        'organizationsAndCompanies': ((json['organizationsAndCompanies'] as Array<any>).map(OrganizationAndCompaniesFromJSON)),
        'edrMatches': json['edrMatches'],
        'nameOfCompanyThatUserWantedToJoinButIsArchived': json['nameOfCompanyThatUserWantedToJoinButIsArchived'] == null ? undefined : json['nameOfCompanyThatUserWantedToJoinButIsArchived'],
    };
}

export function StepCompanyChoiceToJSON(value?: StepCompanyChoice | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...SignupStepToJSON(value, true),
        'organizationsAndCompanies': ((value['organizationsAndCompanies'] as Array<any>).map((v) => OrganizationAndCompaniesToJSON(v))),
        'edrMatches': value['edrMatches'],
        'nameOfCompanyThatUserWantedToJoinButIsArchived': value['nameOfCompanyThatUserWantedToJoinButIsArchived'],
    };
}

